import { createColumnDatetime, createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import moment from "moment";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "refUser.username", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.user.refPersonType"), dataIndex: "refUser.refPersonType.value", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.name"),
            dataIndex: "refUser.companyNameTh",
            dataIndexValue: ({ record }) => (record.refUser?.refPersonType?.key === "1" ? record.refUser?.companyNameTh : record.refUser?.fullNameTh),
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.durationTime"),
            dataIndex: " ",
            dataIndexValue: ({ record }) => {
                let startDatetime = moment(record.startDatetime); //now
                let endDatetime = moment(record.endDatetime);
                let durationDays = moment(endDatetime).diff(startDatetime, 'days');
                let durationTimes = moment.utc(endDatetime.diff(startDatetime)).format("HH:mm");
                return durationDays + " วัน " + durationTimes;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: false,
        }),
        createColumnDatetime({ title: () => i18n.global.t("views.report.startDatetime"), dataIndex: "startDatetime", align: "center" }),
        createColumnDatetime({ title: () => i18n.global.t("views.report.endDatetime"), dataIndex: "endDatetime", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("views.report.ip"), dataIndex: "ip", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.result"),
            dataIndexValue: ({ record }) => (record.error ? "ไม่สำเร็จ" : "สำเร็จ"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
